import { Components, Theme } from "@mui/material";

export const MuiCardHeader: Components<Theme>["MuiCardHeader"] = {
  styleOverrides: {
    root: {
      borderBottom: "1px solid #8080801f",
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
};
